<div>
  <span *ngIf="label" class="p3">{{label}}</span>
  <span *ngIf="labelOptional" class="p5 grey-text">({{labelOptional}})</span>
</div>

<form [formGroup]="inputGroup">
  <input
    #input 
    *ngIf="mode === 'single'"
    [name]="fieldName"
    [formControlName]="fieldName"
    [type]="type"
    autocomplete="off"
    [value]="value"
    [readonly]="disabled || readonly"
    [placeholder]="placeholder"
    (input)="inputHandler()"
    [ngClass]="{ 'button_padding': buttonIcon, 'showError': (showError && inputGroup.controls[fieldName]?.touched), 'readonly': readonly }"
    (focus)="onFocus.emit()"
    (blur)="onBlur.emit()"
  />

  <!-- TODO: implement textarea autosize -->
  <!-- <textarea
    #input
    oninput="this.parentNode.dataset.value = this.value"
    rows="1"
    *ngIf="type === 'multiline'"
    [value]="value" 
    [disabled]="disabled"
    [placeholder]="placeholder"
  ></textarea> -->

  <textarea
    #inputMultiline
    autosize
    rows="1"
    [minRows]="1"
    *ngIf="mode === 'multiline'"
    [name]="fieldName"
    [formControlName]="fieldName"
    autocomplete="off"
    [value]="value" 
    [readonly]="disabled || readonly"
    [placeholder]="placeholder"
    (input)="inputHandler()"
    [ngClass]="{ 'button_padding': buttonIcon, 'showError': (showError && inputGroup.controls[fieldName]?.touched), 'readonly': readonly }"
    (focus)="onFocus.emit()"
    (blur)="onBlur.emit()"
  ></textarea>

  <app-button
    *ngIf="buttonIcon"
    class="trailing-button"
    [icon]="buttonIcon"
    (click)="onButtonClick($event)"
  ></app-button>
</form>

<span *ngIf="errorHint" class="p5 red-text">{{errorHint}}</span>

